import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getDatabase, ref, get, remove } from 'firebase/database';
import { database } from '../../firebase';
import Style from '../assets/css/drawings.module.css';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

const Drawings = ({ user }) => {
    const allowedUser =[
        'mixtecnautas@gmail.com'
    ]
    const [images, setImages] = useState([]);
    const navigate = useNavigate();
    const handleAgregarConstelacionClick = () => {
        navigate('/draw2D');
    };

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const imagesRef = ref(database, 'shared/images');
                const imagesSnapshot = await get(imagesRef);
                const imagesData = imagesSnapshot.val();
                if (imagesData) {
                    const imagesArray = Object.keys(imagesData).map((key) => ({
                        id: key,
                        storyText: imagesData[key].storyText,
                        ...imagesData[key],
                    }));
                    setImages(imagesArray);
                }
            } catch (error) {
                console.error('Error fetching images:', error);
            }
        };

        fetchImages();
    }, []);

    // const handleImageClick = (imageId) => {
    //     navigate(`/drawings/${imageId}`);     
    // };

    const { t } = useTranslation();
    const handleDelete = async (id) => {
            Swal.fire({
                title: t('confirmDelete'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                customClass: {
                    confirmButton: Style.swal2ConfirmBtnDelete,
                    cancelButton: Style.swal2CancelBtnCancel,
                }
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const db = getDatabase();
                    const imageRef = ref(db, `shared/images/${id}`);
                    try {
                        // Eliminar la imagen de la base de datos
                        await remove(imageRef);
                        setImages((prevImages) => prevImages.filter((image) => image.id !== id));
                        Swal.fire({
                            icon: 'success',
                            title: t('deleted'),
                            text: 'Imagen borrada con exito',
                            confirmButtonText: 'OK',
                        });
                    } catch (error) {
                        console.error('Error deleting image:', error);
                        Swal.fire({
                            icon: 'error',
                            title: t('error'),
                            text: 'Hubo un problema borrando la imagen.',
                            confirmButtonText: 'Intenta de nuevo',
                        });
                    }
                }
            });
        };

    return (
        <div className={Style.drawingsContainer}>
            <div className={Style.titleContainer}>
                <h1>Stargram</h1>
                <button className={Style.agregarConstelacionButton} onClick={handleAgregarConstelacionClick}>
                    Agregar Constelación
                </button>
            </div>
            <div className={Style.imagesContainer}>
                {images.map((image) => (
                    <div key={image.id} className={Style.imageCard} >
                        <img src={image.imageURL} alt={image.imageName} className={Style.image} />
                        <h2 className={Style.imageTitle}>{image.imageName}</h2>
                        <p className={Style.imageStory}>{image.storyText}</p>
                        <p className={Style.imageBy}>By: {image.userName}</p>
                        {user && allowedUser.includes(user.email) && (
                        <button onClick={() => handleDelete(image.id)} className={Style.deleteButton}>
                            {t('delete')}
                        </button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Drawings;
